import { icon } from './icons.js';

const THEME_KEY = 'apx-admin:theme';
type Theme = 'dark' | 'light';

function readStored(): Theme {
  const v = localStorage.getItem(THEME_KEY);
  return v === 'light' ? 'light' : 'dark';
}

function apply(theme: Theme): void {
  const root = document.documentElement;
  root.classList.remove('theme-dark', 'theme-light');
  root.classList.add(`theme-${theme}`);
  const btn = document.getElementById('theme-toggle');
  if (btn) {
    // Show the opposite-mode icon/label so the control reads as "switch to X".
    // Inject into child slots when present (the account menu row) so the row's
    // label survives; fall back to the button's own innerHTML otherwise.
    const iconSlot = btn.querySelector('.theme-ic') ?? btn;
    iconSlot.innerHTML = theme === 'dark' ? icon('sun') : icon('moon');
    const labelSlot = btn.querySelector('.theme-label');
    if (labelSlot) labelSlot.textContent = theme === 'dark' ? 'Switch to light' : 'Switch to dark';
  }
}

export function installTheme(): void {
  apply(readStored());
  const btn = document.getElementById('theme-toggle');
  btn?.addEventListener('click', () => {
    const next: Theme = readStored() === 'dark' ? 'light' : 'dark';
    localStorage.setItem(THEME_KEY, next);
    apply(next);
  });
}
